import React, { ReactNode } from 'react';
import { Grid } from '@mui/material';

const KPIBanner = ({
    children,
}: {
    children: ReactNode;
}): React.JSX.Element => {
    return (
        <Grid container id='kpi-banner'>
            {children}
        </Grid>
    );
};

export default KPIBanner;
